import { Element } from '../../../common/html/element'

const ActiveIcon = ({ isRead }) => {
  return (
    <Element
      style={{
        width: '8px',
        height: '8px',
        backgroundColor: !isRead ? '#2C73E8' : 'transparent',
        borderRadius: '8px',
      }}
    />
  )
}

export default ActiveIcon
